"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionAfterViewObserver = void 0;
var React = _interopRequireWildcard(require("react"));
var _percentVisible = require("../../constants/percentVisible");
var _createChild = require("./internal/createChild");
var _useGetCallback = require("./internal/useGetCallback");
var _defaultCallbackDelay = require("../../constants/defaultCallbackDelay");
var _useInView = require("./internal/useInView");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ActionAfterViewObserver = props => {
  const {
    percentVisible = _percentVisible.EPercentVisible.Percent50,
    callbackDelay = _defaultCallbackDelay.DEFAULT_CALLBACK_DELAY,
    trackVisibility,
    triggerOnce = true
  } = props;
  const timerRef = React.useRef();
  const {
    ref,
    inView,
    entry
  } = (0, _useInView.useInView)({
    threshold: percentVisible,
    /** Для IntersectionObserver мы всегда выключаем опцию triggerOnce, т.к без этого не получится сделать отмену вызова по таймеру */
    triggerOnce: false,
    trackVisibility,
    delay: trackVisibility ? 150 : undefined
  });
  const callback = (0, _useGetCallback.useGetCallback)(props.callback, triggerOnce);
  React.useEffect(() => {
    if (inView) {
      /**
       * Если элемент попал в вьюпорт и продолжает в нем быть,
       * то через время callbackDelay вызовется коллбэк
       * */
      timerRef.current = window.setTimeout(() => {
        /**
         * Если отслеживается видимость, нужно так же проверить, чтоб блок был видимым
         * Фича IntersectionObserver v2
         * */
        /* istanbul ignore next не получается покрыть через тесты */
        if (!trackVisibility || entry?.isVisible) {
          callback();
        }
        clearTimeout(timerRef.current);
        timerRef.current = undefined;
      }, callbackDelay);

      /**
       * В случае, когда inView меняется с false на true (элемент появляется), запланируем отмену setTimeout
       * Т.е когда inView изменится обратно с true на false (элемент скроется), setTimeout отменится
       * Это нужно, чтоб коллбэк не вызвался, если не прошло необходимое время (callbackDelay)
       * */
      return () => {
        clearTimeout(timerRef.current);
        timerRef.current = undefined;
      };
    } else {
      /** В случае, когда inView меняется с true на false, нам не нужно планировать отмену таймера */
      return undefined;
    }
  }, [callback, entry, inView, callbackDelay, trackVisibility]);
  return (0, _createChild.createChild)(props, ref);
};
exports.ActionAfterViewObserver = ActionAfterViewObserver;
ActionAfterViewObserver.displayName = 'ActionAfterViewObserver';